import { render, staticRenderFns } from "./CourseBuilderHeader.vue?vue&type=template&id=019fd5e3&scoped=true&"
import script from "./CourseBuilderHeader.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019fd5e3",
  null
  
)

export default component.exports